{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "disclaimer": "aviOS supports your readiness. Acceptance remains with the FAA and your certificate.",
  "anchors": [
    {
      "id": "ac-120-78b",
      "label": "AC 120-78B"
    },
    {
      "id": "a025",
      "label": "OpSpec/MSpec/LOA A025"
    },
    {
      "id": "p43-9",
      "label": "14 CFR §43.9"
    },
    {
      "id": "p43-11",
      "label": "14 CFR §43.11"
    },
    {
      "id": "p91-417",
      "label": "14 CFR §91.417"
    },
    {
      "id": "p135-records",
      "label": "Part 135 Records"
    },
    {
      "id": "part-39",
      "label": "Part 39 ADs"
    },
    {
      "id": "part-145",
      "label": "Part 145"
    },
    {
      "id": "part-65",
      "label": "Part 65"
    }
  ]
}